module.exports = __webpack_public_path__ + "static/img/20181205021.161a4dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/20181205021.jpg
// module id = rFwl
// module chunks = 1